export class StringUtilsHelper {
    public static suffixIfNotNull(string: string, suffix: string) {
        return !string || string === '' ? '' : string + suffix;
    }

    public static prefixIfNotNull(string: string, prefix: string) {
        return !string || string === '' ? '' : prefix + string;
    }
}
